<template>
    <v-expansion-panels v-model="panel">
        <v-expansion-panel>
            <v-expansion-panel-header class="headline">{{ $t('filters') }}</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row>
                    <v-col class="col-12 col-sm-6 d-flex justify-center">
                        <v-autocomplete v-model="activeFilters.showcase_status" :label="statuses.label"
                            :items="statuses.valuesData" item-text="name" item-value="value" @change="filterChange"
                            hide-no-data clearable multiple color="teal lighten-2" item-color="teal lighten-2"></v-autocomplete>
                    </v-col>
                    <v-col class="col-12 col-sm-6 d-flex justify-center">
                        <v-autocomplete v-model="activeFilters.showcase_source_type" :label="sourceTypes.label"
                            :items="sourceTypes.valuesData" item-text="name" item-value="value" @change="filterChange"
                            hide-no-data clearable multiple color="teal lighten-2" item-color="teal lighten-2"></v-autocomplete>
                    </v-col>
                </v-row>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import { MixinFiltersGeneral } from '../../mixins'
import { FilterService } from "../../services";

export default {
    name: "PartnerManufacturerShowcasesFilters",
    mixins: [MixinFiltersGeneral],
    data() {
        return {
            panel: null,
            activeFilters: {},
            layout: [],
        }
    },
    computed: {
        statuses() {
            return this.layout.find(item => item.systemName === 'showcase_status') || {};
        },
        sourceTypes() {
            return this.layout.find(item => item.systemName === 'showcase_source_type') || {};
        },
    },
    methods: {
        getLayout() {
            this.setFiltersFromUrl();
            FilterService.setAuth(this.$store.getters.token);

            return FilterService.getPartnerManufacturerShowcasesLayout()
                .then(res => {
                    this.layout = [...res.data];
                })
                .catch(err => {
                    console.log(err);
                });
        },
        filterChange() {
            this.addFiltersToUrl(this.activeFilters);
            this.$emit('filter-change', { ...this.activeFilters });
        },
        setFiltersFromUrl() {
            this.activeFilters = this.getFiltersFromUrl();
            this.filterChange();
        },
    },
    created() {
        this.getLayout();
    },
}
</script>
